"use client";

import { c as _c } from "react/compiler-runtime";
import { FlagContext } from "./FlagContext";
export const FlagProvider = t0 => {
  const $ = _c(8);
  const {
    children,
    flags: t1,
    flagsReady: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const flags = t3;
  const flagsReady = t2 === undefined ? false : t2;
  let t4;
  if ($[2] !== flags || $[3] !== flagsReady) {
    t4 = {
      flags,
      flagsReady
    };
    $[2] = flags;
    $[3] = flagsReady;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4) {
    t5 = <FlagContext.Provider value={t4}>{children}</FlagContext.Provider>;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};